// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 362 ? "b6715477" : chunkId) + "." + {"36":"6f07929eb0102ff4","362":"a1cd3e412d153bc9"}[chunkId] + ".js";
};